import { SmartAppBannerLazyLoaderV1 } from './smartAppBannerLazyLoaderV1';

const props = [];

export const SmartAppBannerDirective = reactDirective => reactDirective(SmartAppBannerLazyLoaderV1, props);
SmartAppBannerDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('smartAppBannerV1', SmartAppBannerDirective);
